var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizaPentruTensiuneRedusaDeProtectie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28C27.0677 22.3231 31.8447 18 37.5499 18L38.9875 18C44.5963 18 49.2199 22.3982 49.5 28V28L26.5 28V28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 17L38 -1.26965e-06",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45C23.7059 6.58705 53.2298 8.76238 54 44.9992",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizaPentruTensiuneRedusaDeProtectie);
export default __webpack_public_path__ + "static/media/priza_pentru_tensiune_redusa_de_protectie.b0917f824f0922c034911a06eb280cf4.svg";
export { ForwardRef as ReactComponent };